const CALLABLE_PREFIX = 'callablesAuth_';
export const getWorkflowsAndUsers = (functions) => {
  return functions.httpsCallable(CALLABLE_PREFIX + 'getWorkflowsAndUsers');
};